import { SEGMENT_COLORS } from "pages/price-management/PriceManagement/variables";
import { Tag } from "antd";

export const segmentWithColor = segment => (
  <span style={{ color: SEGMENT_COLORS[segment] }}>{segment || <Tag color={"gold"}>{"-"}</Tag>}</span>
);
